import axios from "axios";
import {
  adaAPIsBaseUrlNA,
  batchOpsBaseURL,
  adaAPIEndpoints,
  batchOpsAPIEndpoints,
  token,
  adaApiKey,
  batchOpsBaseURLDev,
  adaAPIsBaseUrlEU,
  batchOpsApiKey,
  adaApiKeyEU,
} from "../config.js";

const adaApiNA = axios.create({
  baseURL: adaAPIsBaseUrlNA,
});
const adaApiEU = axios.create({
  baseURL: adaAPIsBaseUrlEU,
});
const batchOpsAPI = axios.create({
  baseURL: batchOpsBaseURL,
});
const batchOpsAPIDev = axios.create({
  baseURL: batchOpsBaseURLDev,
});

const adaAPIHeaders = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  "Access-Control-Allow-Origin": "*",
};

const batchOpsAPIHeaders = {
  Authorization: `Bearer ${token}`,
  "X-Api-Key": batchOpsApiKey,
};

export function getFeature(fname, region) {
  return new Promise(async (resolve, reject) => {
    try {
      const adaAPI = region === "na" ? adaApiNA : adaApiEU;
      const headers = {
        ...adaAPIHeaders,
        "X-Api-Key": region === "na" ? adaApiKey : adaApiKeyEU,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
      };
      const response = await adaAPI.get(adaAPIEndpoints.policyEndpoint, {
        params: { fname },
        headers: headers,
      });
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
}

export function getPolicy(policyId, region) {
  return new Promise(async (resolve, reject) => {
    try {
      const adaAPI = region === "na" ? adaApiNA : adaApiEU;
      const headers = {
        ...adaAPIHeaders,
        "X-Api-Key": region === "na" ? adaApiKey : adaApiKeyEU,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
      };
      const response = await adaAPI.get(
        `${adaAPIEndpoints.policyEndpoint}/${policyId}`,
        { headers: headers }
      );
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
}

export function getVINProfile(vin, region) {
  return new Promise(async (resolve, reject) => {
    const adaAPI = region === "na" ? adaApiNA : adaApiEU;
    console.log(adaAPI, region === "na" ? adaApiKey : adaApiKeyEU);
    const headers = {
      ...adaAPIHeaders,
      "X-Api-Key": region === "na" ? adaApiKey : adaApiKeyEU,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Content-Type, Authorization",
    };
    try {
      const response = await adaAPI.get(
        `${adaAPIEndpoints.vinProfileEndpoint}/${vin}`,
        { headers: headers }
      );
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
}

export function getVINProfileByDevice(vin, region) {
  return new Promise(async (resolve, reject) => {
    const adaAPI = region === "na" ? adaApiNA : adaApiEU;
    const headers = {
      ...adaAPIHeaders,
      "X-Api-Key": region === "na" ? adaApiKey : adaApiKeyEU,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Content-Type, Authorization",
    };
    try {
      const response = await adaAPI.get(
        `${adaAPIEndpoints.vinProfileByDeviceEndpoint}/${vin}`,
        { headers: headers }
      );
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
}

export function startNewUpdate(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await batchOpsAPI.post(
        batchOpsAPIEndpoints.newUpdateEndpoint,
        payload,
        { headers: batchOpsAPIHeaders }
      );
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
}

export function getUpdatesHistory(cursor = null, page = 0) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await batchOpsAPI.get(
        batchOpsAPIEndpoints.listUpdatesEndpoint,
        { headers: batchOpsAPIHeaders, params: { cursor: cursor, page: page } }
      );
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
}

export function getGraphData(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await batchOpsAPIDev.get(
        batchOpsAPIEndpoints.getStaticGraphDataEndpoint,
        { params: data, headers: batchOpsAPIHeaders }
      );
      resolve(response.data);
    } catch (cause) {
      reject(cause);
    }
  });
}

export function getLiveUpdate() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await batchOpsAPI.get(
        batchOpsAPIEndpoints.liveStatusEndpoint,
        { headers: batchOpsAPIHeaders }
      );
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
}

export function getDownloadFile(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await batchOpsAPI.post(
        batchOpsAPIEndpoints.downloadEndpoint,
        payload,
        { headers: batchOpsAPIHeaders }
      );
      resolve(response.data);
    } catch (err) {
      reject(err);
    }
  });
}
